import React, { useContext, useState } from 'react';
import { Formik, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { ModalContext } from 'context/ModalContext';
import { show_toast } from 'utils/helpers';
import Select from "react-select";
import { X } from 'react-feather';
import { FetchInsuranceClasses, get_valuer_panel, register_valuer_config } from 'services/apiSrv';
import { listServiceProviders } from 'services/serviceProviderSrv';
import { useQuery } from 'react-query';


export default function Add_ValuationConfig({ onAdd }) {
  const { modalClose } = useContext(ModalContext);
  const [panelInput, setPanelInput] = useState([]);

  async function fetchServiceProviders(){
    const response = await listServiceProviders()
    return response.data
  }

  
  const {
    data: subclasses = [],
    isLoading: isSubclasses,
    error: subclassError,
  } = useQuery({
    queryKey: ['insuranceClasses'],
    queryFn: FetchInsuranceClasses,
  });
  const {
    data: valuers = [],
    isLoading: isValuers,
    error: subvaluerError,
  } = useQuery({
    queryKey: ['valuer_panel'],
    queryFn: fetchServiceProviders,
  });
  console.log('valuers', valuers)

  const templates = [
    { id: 'T-RES', title: 'Residential Template', desc: 'Residences, houses and apartments' },
    { id: 'T-VEH', title: 'Vehicle Template', desc: 'Cars, motorcycles and light vehicles' },
    { id: 'T-COM', title: 'Commercial Template', desc: 'Shops, offices and commercial premises' },
  ];

  const maxPeriods = [
    { value: '7', label: '7 days' },
    { value: '14', label: '14 days' },
    { value: '30', label: '30 days' },
    { value: '90', label: '90 days' },
    { value: '365', label: '1 year' },
  ];

  const inputStyle = {
    padding: '0.7rem 0.9rem',
    border: '1px solid #e6e8eb',
    borderRadius: '0.5rem',
    backgroundColor: '#fff',
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.6)',
  };

  const selectStyle = {
    ...inputStyle,
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    paddingRight: '2.8rem',
    backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'><path fill='%23909ca6' d='M6 8L0 0h12z'/></svg>")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 12px center',
    minHeight: '44px',
  };

  const sectionTitleStyle = { fontWeight: 700, color: '#374151', marginBottom: 8, fontSize: 14 };
  const smallMuted = { color: '#6b7280', fontSize: 13 };
  const formGroupStyle = { marginBottom: 14 };

  const serviceProviders = valuers[0]?.service_providers || [];

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Configuration name is required'),
    description: Yup.string().nullable(),
    template: Yup.string().required('Please select a template'),
    maxPeriod: Yup.string().required('Please select maximum valuation period'),
    clientCanAppoint: Yup.string().oneOf(['yes', 'no']).required('Required'),
    defaultValuer: Yup.string().nullable(),
    riskValueAction: Yup.string().nullable(),
    isDefaultForAllInsuranceClass: Yup.string().oneOf(['true', 'false']).required('Required'),
    insuranceClassSystemRef: Yup.string().when('isDefaultForAllInsuranceClass', {
      is: 'false',
      then: (s) => s.required('Please select an insurance class'),
      otherwise: (s) => s.nullable(),
    }),
  });

  return (
    <div className="p-4 bg-white rounded" style={{ boxShadow: '0 6px 20px rgba(11,23,39,0.04)' }}>
      <Formik
        initialValues={{
          name: '',
          description: '',
          template: '',
          maxPeriod: '30',
          clientCanAppoint: 'no',
          requestInitiation: [],
          defaultValuer: '',
          riskValueAction: 'auto',
          panelMembers: [],
          isDefaultForAllInsuranceClass: 'false',
          insuranceClassSystemRef: '',
        }}
        validationSchema={validationSchema}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          setSubmitting(true);
          try {
            const newCfg = {
              valuationConfigName: values.name,
              valuationConfigDescription: values.description || '',
              valuationConfigSystemRef: '',
              insuranceClassSystemRef: values.isDefaultForAllInsuranceClass === 'true' ? '' : values.insuranceClassSystemRef,
              isDefaultForAllInsuranceClass: values.isDefaultForAllInsuranceClass === 'true',
              valuationsTemplates: [],
              defaultValuationEmailRequestTemplate: values.template,
              maximumValuationPeriod: Number(values.maxPeriod),
              isClientAllowedToChoose: values.clientCanAppoint === 'yes',
              requestInitiation: values.requestInitiation || [],
              defaultValuer: values.defaultValuer || null,
              riskValueAction: values.riskValueAction || null,
              valuers: values.panelMembers || [],
            };

            if (typeof onAdd === 'function') onAdd(newCfg);
            

            show_toast('Configuration added', 'success');
            resetForm();
            setPanelInput('');
            setSubmitting(false);
            modalClose();
          } catch (err) {
            console.error(err);
            show_toast('Failed to add configuration', 'error');
            setSubmitting(false);
          }
        }}
      >
        {({ values, handleChange, setFieldValue, isSubmitting }) => {
          console.log("valuers", values)
          
          const addPanelMember = () => {
            const name = (panelInput || '').trim();
            if (!name) return;
            if ((values.panelMembers || []).includes(name)) {
              show_toast('Panel member already added', 'warning');
              return;
            }
            setFieldValue('panelMembers', [name, ...(values.panelMembers || [])]);
            setPanelInput('');
          };

          const removePanelMember = (n) => {
            setFieldValue(
              'panelMembers',
              (values.panelMembers || []).filter((x) => x !== n)
            );
          };

          const toggleRequestInitiation = (type) => {
            const curr = values.requestInitiation || [];
            if (curr.includes(type)) {
              setFieldValue('requestInitiation', curr.filter((x) => x !== type));
            } else {
              setFieldValue('requestInitiation', [...curr, type]);
            }
          };

          const handleTemplateKey = (e, id) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setFieldValue('template', id);
            }
          };

          const isNewPolicy = (values.requestInitiation || []).includes('new_policy');
          const isRenewals = (values.requestInitiation || []).includes('renewals');

        
          const yesRadio = (
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="clientCanAppoint"
                id="appointYes"
                value="yes"
                checked={values.clientCanAppoint === 'yes'}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="appointYes">
                Yes
              </label>
            </div>
          );

          const noRadio = (
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="clientCanAppoint"
                id="appointNo"
                value="no"
                checked={values.clientCanAppoint === 'no'}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="appointNo">
                No
              </label>
            </div>
          );

          const newPolicyCheckbox = (
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="initNewPolicy"
                checked={isNewPolicy}
                onChange={() => toggleRequestInitiation('new_policy')}
              />
              <label className="form-check-label" htmlFor="initNewPolicy">
                New Policy
              </label>
            </div>
          );

          const renewalsCheckbox = (
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="initRenewals"
                checked={isRenewals}
                onChange={() => toggleRequestInitiation('renewals')}
              />
              <label className="form-check-label" htmlFor="initRenewals">
                Renewals
              </label>
            </div>
          );

          // -----------------------------------------------------------------
          // Render
          // -----------------------------------------------------------------
          return (
            <Form>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {/* ---------- Name ---------- */}
                <div style={formGroupStyle}>
                  <label style={sectionTitleStyle}>
                    Configuration Name <span className="text-danger">*</span>
                  </label>
                  <input
                    name="name"
                    type="text"
                    className="form-control"
                    value={values.name}
                    onChange={handleChange}
                    style={inputStyle}
                  />
                  <ErrorMessage name="name" component="div" className="invalid-feedback d-block" />
                </div>

                {/* ---------- Description ---------- */}
                <div style={formGroupStyle}>
                  <label style={{ ...sectionTitleStyle, fontWeight: 600 }}>Description</label>
                  <textarea
                    name="description"
                    className="form-control"
                    rows={2}
                    value={values.description}
                    onChange={handleChange}
                    style={{ ...inputStyle, minHeight: 80 }}
                  />
                </div>

                {/* ---------- Templates ---------- */}
                <div style={formGroupStyle}>
                  <label style={sectionTitleStyle}>
                    Select Valuation Template <span className="text-danger">*</span>
                  </label>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    {templates.map((t) => {
                      const selected = values.template === t.id;
                      return (
                        <div
                          key={t.id}
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => handleTemplateKey(e, t.id)}
                          onClick={() => setFieldValue('template', t.id)}
                          className="card p-3"
                          style={{
                            cursor: 'pointer',
                            borderRadius: 10,
                            boxShadow: selected
                              ? '0 10px 28px rgba(21,91,212,0.12)'
                              : '0 4px 12px rgba(15,23,42,0.04)',
                            border: selected ? '1px solid #155bd4' : '1px solid #e6e8eb',
                            background: selected ? '#f0f9ff' : '#fff',
                            transition: 'transform 0.12s ease, box-shadow 0.12s ease',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            minHeight: 78,
                            outline: 'none',
                          }}
                        >
                          <div>
                            <div style={{ fontWeight: 700, fontSize: 15 }}>{t.title}</div>
                            <div style={{ ...smallMuted, marginTop: 4 }}>{t.desc}</div>
                          </div>
                          {selected && (
                            <div style={{ marginTop: 6, color: '#155bd4', fontWeight: 600 }}>
                              Selected
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                  <ErrorMessage name="template" component="div" className="invalid-feedback d-block" />
                </div>

                {/* ---------- Client + Max period + Insurance class + Default for all ---------- */}
                <div style={{ ...formGroupStyle, padding: '12px 0' }}>
                  <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                    {/* Left column */}
                    <div style={{ flex: '1 1 280px', minWidth: 220 }}>
                      <label style={sectionTitleStyle}>Client allowed to appoint valuers?</label>
                      <div className="d-flex align-items-center" style={{ gap: 12, marginBottom: 10 }}>
                        {yesRadio}
                        {noRadio}
                      </div>

                      <div style={{ marginTop: 8 }}>
                        <label style={{ ...sectionTitleStyle, display: 'block', marginBottom: 8 }}>
                          Maximum valuation period
                        </label>
                        <select
                          name="maxPeriod"
                          value={values.maxPeriod}
                          onChange={handleChange}
                          className="form-select"
                          style={{ ...selectStyle, display: 'block', marginTop: 6, width: '100%', maxWidth: '260px' }}
                        >
                          {maxPeriods.map((m) => (
                            <option key={m.value} value={m.value}>
                              {m.label}
                            </option>
                          ))}
                        </select>
                        <ErrorMessage name="maxPeriod" component="div" className="invalid-feedback d-block" />
                      </div>

                      {/* Insurance Class (only shown when NOT default for all) */}
                      {values.isDefaultForAllInsuranceClass === 'false' && (
                        <div style={{ marginTop: 12 }}>
                          <label style={{ ...sectionTitleStyle, display: 'block', marginBottom: 8 }}>
                            Insurance Class <span className="text-danger">*</span>
                          </label>
                          <select
                            name="insuranceClassSystemRef"
                            value={values.insuranceClassSystemRef}
                            onChange={handleChange}
                            className="form-select"
                            style={{ ...selectStyle, display: 'block', width: '100%', maxWidth: '260px' }}
                          >
                            <option value="">Select class</option>
                            {subclasses?.data?.map((cls) => (
                              <option key={cls.id} value={cls.id}>
                                {cls.name}
                              </option>
                            ))}
                          </select>
                          <ErrorMessage
                            name="insuranceClassSystemRef"
                            component="div"
                            className="invalid-feedback d-block"
                          />
                        </div>
                      )}
                    </div>

                    {/* Right column – Default for all + Default valuer + Risk action */}
                    <div style={{ flex: '1 1 280px', minWidth: 220 }}>
                      <label style={{ ...sectionTitleStyle, display: 'block', marginBottom: 8 }}>
                        Is default for Insurance Classes
                      </label>
                      <select
                        name="isDefaultForAllInsuranceClass"
                        value={values.isDefaultForAllInsuranceClass ?? ''}
                        onChange={handleChange}
                        className="form-select"
                        style={{ ...selectStyle, display: 'block', marginTop: 6, width: '100%', maxWidth: '260px' }}
                      >
                        <option value="">select</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                      <ErrorMessage
                        name="isDefaultForAllInsuranceClass"
                        component="div"
                        className="invalid-feedback d-block"
                      />

                      <div style={{ marginTop: 12 }}>
                        <label style={{ ...sectionTitleStyle, display: 'block', marginBottom: 8 }}>
                          Default Valuer
                        </label>
                        <select
                          name="defaultValuer"
                          value={values.defaultValuer || ''}
                          onChange={handleChange}
                          className="form-select"
                          style={{ ...selectStyle, display: 'block', marginTop: 6, width: '100%', maxWidth: '260px' }}
                        >
                          <option value="">Select default valuer</option>
                          {serviceProviders.map((v) => (
                            <option key={v.serviceProviderSystemRef} value={v.serviceProviderSystemRef}>
                              {v.serviceProviderNames}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div style={{ marginTop: 12 }}>
                        <label style={sectionTitleStyle}>Risk value change</label>
                        <div className="d-flex" style={{ gap: 12, marginTop: 6, flexWrap: 'wrap' }}>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              id="riskAuto"
                              name="riskValueAction"
                              value="auto"
                              checked={values.riskValueAction === 'auto'}
                              onChange={handleChange}
                            />
                            <label className="form-check-label" htmlFor="riskAuto">
                              Auto raise
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              id="riskNote"
                              name="riskValueAction"
                              value="note"
                              checked={values.riskValueAction === 'note'}
                              onChange={handleChange}
                            />
                            <label className="form-check-label" htmlFor="riskNote">
                              Note
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              id="riskIds"
                              name="riskValueAction"
                              value="ids"
                              checked={values.riskValueAction === 'ids'}
                              onChange={handleChange}
                            />
                            <label className="form-check-label" htmlFor="riskIds">
                              IDs
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ---------- Request initiation ---------- */}
                <div style={formGroupStyle}>
                  <label style={sectionTitleStyle}>Valuation request initiation</label>
                  <div className="d-flex" style={{ gap: 12, alignItems: 'center' }}>
                    {newPolicyCheckbox}
                    {renewalsCheckbox}
                  </div>
                </div>

                {/* ---------- Panel members ---------- */}
                <div style={formGroupStyle}>
                  <label style={sectionTitleStyle}>Valuation Panel Members</label>
                  <div className="mt-2">
                    {Array.isArray(values.panelMembers) && values.panelMembers.length === 0 ? (
                      <div className="text-muted">No panel members added yet</div>
                    ) : (
                      // <div className="d-flex flex-wrap gap-2">
                      //   {values.panelMembers.map((m) => (
                      //     <div
                      //       key={m}
                      //       className="badge bg-primary bg-opacity-10 text-primary d-flex align-items-center gap-2 px-3 py-2 border"
                      //       style={{ fontSize: '0.9rem' }}
                      //     >
                      //       {/* {m}  */}
                      //       {valuers.find((valuer) => valuer.serviceProviderSystemRef === m)?.[0]?.serviceProviderNames}
                      //       <X size={14} style={{ cursor: 'pointer' }} onClick={() => removePanelMember(m)} />
                      //     </div>
                      //   ))}
                      // </div>
                      <div className="d-flex flex-wrap gap-2">
                      {values.panelMembers.map((id) => {
                        const valuer = serviceProviders.find(v => v.serviceProviderSystemRef === id);
                        const displayName = valuer?.serviceProviderNames || id || 'Unknown valuer';

                        return (
                          <div
                            key={id}
                            className="badge bg-primary bg-opacity-10 text-primary d-flex align-items-center gap-2 px-3 py-2 border"
                            style={{ fontSize: '0.9rem' }}
                          >
                            {displayName}
                            <X size={14} style={{ cursor: 'pointer' }} onClick={() => removePanelMember(id)} />
                          </div>
                        );
                      })}
                    </div>
                    )}
                  </div>
                </div>

          <div className="col-12 my-2">
            <label className="form-label fw-semibold">
              Allowed Panel Members <span className="text-danger">*</span>
            </label>

            <Select
              isMulti
              name="panelMembers"
              options={
                serviceProviders?.map((valuer) => ({
                  value: valuer.serviceProviderSystemRef,
                  label: valuer.serviceProviderNames,
                })) || []
              }
              value={
                // Map the current selected IDs (values.panelMembers) back to option objects
                values.panelMembers
                  ? values.panelMembers
                      .map((selectedId) => {
                        const valuer = serviceProviders?.find(
                          (v) => v.serviceProviderSystemRef === selectedId
                        );
                        return valuer
                          ? { value: valuer.serviceProviderSystemRef, label: valuer.serviceProviderNames }
                          : null;
                      })
                      .filter(Boolean)
                  : []
              }
              onChange={(selectedOptions) => {
                const selectedValues = selectedOptions
                  ? selectedOptions.map((option) => option.value)
                  : [];
                setFieldValue("panelMembers", selectedValues);
              }}
              className="react-select-container"
              classNamePrefix="react-select"
              placeholder="Select panel members..."
              noOptionsMessage={() => "No valuers available"}
              isLoading={isValuers}
            />

            <ErrorMessage name="panelMembers" component="div" className="invalid-feedback d-block" />
          </div>

                {/* ---------- Buttons ---------- */}
                <div className="d-flex justify-content-end" style={{ gap: '1.5rem', marginTop: '1rem' }}>
                  <button type="button" className="btn btn-secondary" onClick={modalClose} disabled={isSubmitting}>
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                    {isSubmitting ? 'Saving...' : 'Save Configuration'}
                  </button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}